'use client'

import { Amplitude } from '@repo/analytics/amplitude'
import { setAmplitudeTrackingAllowed } from '@repo/analytics/amplitude/utils'
import { useIubendaTrackingState } from '@repo/analytics/iubenda'
import { useIubendaConfig } from './iubenda'

if (typeof window !== 'undefined') {
  setAmplitudeTrackingAllowed('pending')
}

export function IubendaAmplitude() {
  const { variant } = useIubendaConfig()
  const trackingAllowed = useIubendaTrackingState(variant)

  return <Amplitude enabled={trackingAllowed} />
}
